import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom'
import blogs from '../../api/blogs'
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import BlogSingle from '../../components/BlogDetails/BlogDetails';


const BlogDetails = (props) => {

    const { slug } = useParams()

    const BlogDetails = blogs.find(item => item.slug === slug)

    usePageSeo({
        title: BlogDetails?.title || 'Blog',
        description: BlogDetails?.excerpt || 'Insights from BUILDLAB on affordable housing technology, low-voltage design, managed IT, cyber security, and AI.',
        image: BlogDetails?.screens,
        ogType: 'article',
    });

    // BlogPosting structured data for the prerendered article page.
    const SITE_ORIGIN = 'https://www.buildlabconsulting.com';
    const articleSchema = BlogDetails ? {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: BlogDetails.title,
        description: BlogDetails.excerpt || undefined,
        image: BlogDetails.screens ? `${SITE_ORIGIN}${BlogDetails.screens}` : undefined,
        datePublished: BlogDetails.date || undefined,
        dateModified: BlogDetails.date || undefined,
        author: {
            '@type': 'Organization',
            name: 'BUILDLAB',
            url: SITE_ORIGIN,
        },
        publisher: {
            '@type': 'Organization',
            name: 'BUILDLAB',
            logo: { '@type': 'ImageObject', url: `${SITE_ORIGIN}/logo512.png` },
        },
        mainEntityOfPage: `${SITE_ORIGIN}/blog-single/${BlogDetails.slug}/`,
    } : null;

    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content about-page">
                {articleSchema && (
                    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }} />
                )}
                <PageTitle pageTitle={BlogDetails.title} pagesub={'Details '} pageTop={'Blog'}/>
                <BlogSingle/>
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogDetails;